import { render, staticRenderFns } from "./AuthChangePassword.vue?vue&type=template&id=3be9ee13&"
import script from "./AuthChangePassword.vue?vue&type=script&lang=ts&"
export * from "./AuthChangePassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports